module.exports = "https://www.gc-qa.gnp.com.mx/94fb7604e37205318fd49ba88c5b02ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/https_24px_outlined.svg
// module id = 8116
// module chunks = 0